// for api compatibility
import Rewriter from './Rewriter.js';

export default class RewriteForm extends Rewriter {
	static service = 'form';
}
